<template>
  <v-form
    lazy-validation
    ref="refCandidat"
    v-model="$storeBourse.validation.candidat"
  >
    <v-expansion-panels multiple v-model="Panel.Model">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <h3>{{ $storeUm6p.Label.Title.Candidat }}</h3>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="panel-content">
          <!-- Nom,Prénom,Genre -->
          <v-row>
            <v-col cols="4">
              <v-text-field
                :label="$storeUm6p.Label.Candidat.Nom"
                v-model="$storeBourse.DonneesFormulaireEC.nom"
                :disabled="$storeBourse.DonneesFormulaireEC.readOnly"
                :rules="$storeReglesBourse.obligatoire"
                class="asterisk"
                ref="Nom"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :label="$storeUm6p.Label.Candidat.Prenom"
                v-model="$storeBourse.DonneesFormulaireEC.prenom"
                :disabled="$storeBourse.DonneesFormulaireEC.readOnly"
                :rules="$storeReglesBourse.obligatoire"
                class="asterisk"
                ref="Prenom"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-autocomplete
                :label="$storeUm6p.Label.Candidat.Genre"
                v-model="$storeBourse.DonneesFormulaireEC.genre"
                :disabled="$storeBourse.DonneesFormulaireEC.readOnly"
                :rules="$storeReglesBourse.obligatoire"
                ref="Genre"
                :item-text="$storeCommun.ItemLang"
                item-value="id"
                :items="$storeCatalogue.Genre"
                :clearable="!$storeBourse.DonneesFormulaireEC.readOnly"
                class="asterisk"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <!-- Naissance, Situation familiale -->
          <v-row>
            <v-col cols="4">
              <v-menu
                v-model="menu.dateNaissance"
                :disabled="$storeBourse.DonneesFormulaireEC.readOnly"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                :clearable="!$storeBourse.DonneesFormulaireEC.readOnly"
                offset-y
                min-width="auto"
              >
                <template #activator="{ on, attrs }">
                  <v-text-field
                    :clearable="!$storeBourse.DonneesFormulaireEC.readOnly"
                    v-model="DateNaissanceFormated"
                    :label="$storeUm6p.Label.Candidat.DateNaissance"
                    prepend-icon="mdi-calendar"
                    ref="DateNaissance"
                    readonly
                    v-bind="attrs"
                    :disabled="$storeBourse.DonneesFormulaireEC.readOnly"
                    v-on="on"
                    @click:clear="
                      $storeBourse.DonneesFormulaireEC.dateNaissance = null
                    "
                    :rules="$storeReglesBourse.obligatoire"
                    class="asterisk"
                  />
                </template>
                <v-date-picker
                  v-model="$storeBourse.DonneesFormulaireEC.dateNaissance"
                  :max="MaxDateNaissance"
                  :itemprop="$storeUm6p.Label.Candidat.DateNaissance"
                  :clearable="!$storeBourse.DonneesFormulaireEC.readOnly"
                  :disabled="$storeBourse.DonneesFormulaireEC.readOnly"
                  @input="menu.dateNaissance = false"
                  :rules="$storeReglesBourse.obligatoire"
                />
              </v-menu>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :label="$storeUm6p.Label.Candidat.LieuNaissance"
                v-model="$storeBourse.DonneesFormulaireEC.lieuNaissance"
                :disabled="$storeBourse.DonneesFormulaireEC.readOnly"
                :rules="$storeReglesBourse.obligatoire"
                ref="LieuNaissance"
                class="asterisk"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-autocomplete
                :label="$storeUm6p.Label.Candidat.SituationFamiliale"
                v-model="$storeBourse.DonneesFormulaireEC.situationFamiliale"
                :disabled="$storeBourse.DonneesFormulaireEC.readOnly"
                :rules="$storeReglesBourse.obligatoire"
                ref="SituationFamiliale"
                :item-text="$storeCommun.ItemLang"
                item-value="id"
                :items="$storeCatalogue.SituationFamiliale"
                :clearable="!$storeBourse.DonneesFormulaireEC.readOnly"
                class="asterisk"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <!-- Nationalité, mail -->
          <v-row>
            <v-col cols="4">
              <v-autocomplete
                :label="$storeUm6p.Label.Candidat.Nationalite"
                v-model="$storeBourse.DonneesFormulaireEC.nationalite"
                :disabled="$storeBourse.DonneesFormulaireEC.readOnly"
                :rules="$storeReglesBourse.obligatoire"
                ref="Nationalite"
                :item-text="$storeCommun.ItemLang"
                item-value="id"
                :items="$storeCatalogue.Pays"
                :clearable="!$storeBourse.DonneesFormulaireEC.readOnly"
                class="asterisk"
              ></v-autocomplete>
            </v-col>
            <v-col cols="4">
              <v-autocomplete
                :label="$storeUm6p.Label.Candidat.AutreNationalite"
                v-model="$storeBourse.DonneesFormulaireEC.autreNationalite"
                :disabled="$storeBourse.DonneesFormulaireEC.readOnly"
                ref="AutreNationalite"
                :item-text="$storeCommun.ItemLang"
                item-value="id"
                :items="$storeCatalogue.Pays"
                :clearable="!$storeBourse.DonneesFormulaireEC.readOnly"
              ></v-autocomplete>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :label="$storeUm6p.Label.Candidat.Mail"
                v-model="$storeBourse.DonneesFormulaireEC.mail"
                :disabled="$storeBourse.DonneesFormulaireEC.readOnly"
                :rules="$storeReglesBourse.emailObligatoire"
                ref="Mail"
                class="asterisk"
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- cni, passeport, portable -->
          <v-row>
            <v-col cols="4">
              <v-text-field
                :label="
                  $storeBourse.DonneesFormulaireEC.nationalite ===
                  $storeCommun.DataId.Maroc
                    ? $storeUm6p.Label.Parents.Cni
                    : $storeUm6p.Label.Parents.AutreCni
                "
                v-model="$storeBourse.DonneesFormulaireEC.cni"
                disabled
                ref="Cni"
                class="asterisk"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :label="$storeUm6p.Label.Candidat.Portable"
                v-model="$storeBourse.DonneesFormulaireEC.portable"
                :disabled="$storeBourse.DonneesFormulaireEC.readOnly"
                :rules="$storeReglesBourse.telephoneObligatoire"
                ref="Portable"
                class="asterisk"
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- handicap, telfix -->
          <v-row>
            <v-col cols="4">
              <v-autocomplete
                :label="$storeUm6p.Label.Candidat.SituationHandicap"
                v-model="$storeBourse.DonneesFormulaireEC.situationHandicap"
                :disabled="$storeBourse.DonneesFormulaireEC.readOnly"
                :rules="$storeReglesBourse.obligatoire"
                ref="SituationHandicap"
                :item-text="$storeCommun.ItemLang"
                item-value="id"
                :items="$storeCatalogue.OuiNon"
                :clearable="!$storeBourse.DonneesFormulaireEC.readOnly"
                class="asterisk"
                @change="SituationHandicapChange"
              ></v-autocomplete>
            </v-col>
            <v-col cols="4">
              <v-autocomplete
                :label="$storeUm6p.Label.Candidat.TypeHandicap"
                v-model="$storeBourse.DonneesFormulaireEC.typeHandicap"
                :disabled="$storeBourse.DonneesFormulaireEC.readOnly"
                :rules="
                  $storeBourse.DonneesFormulaireEC.situationHandicap ==
                  $storeCatalogue.DataId.Oui
                    ? $storeReglesBourse.multiObligatoire
                    : []
                "
                ref="TypeHandicap"
                :item-text="$storeCommun.ItemLang"
                item-value="id"
                :items="$storeCatalogue.NatureHandicap"
                :clearable="!$storeBourse.DonneesFormulaireEC.readOnly"
                multiple
                v-show="
                  $storeBourse.DonneesFormulaireEC.situationHandicap ==
                  $storeCatalogue.DataId.Oui
                "
                class="asterisk"
              ></v-autocomplete>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :label="$storeUm6p.Label.Candidat.Fixe"
                v-model="$storeBourse.DonneesFormulaireEC.fixe"
                :disabled="$storeBourse.DonneesFormulaireEC.readOnly"
                :rules="$storeReglesBourse.telephone"
                ref="Fixe"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-autocomplete
                label="Comment avez-vous connu l'école Centrale Casablanca ?"
                v-model="$storeBourse.DonneesFormulaireEC.infosComplementaires.connaissanceFirsi"
                :disabled="$storeBourse.DonneesFormulaireEC.readOnly"
                :rules="$storeReglesBourse.obligatoire"
                :item-text="$storeCommun.ItemLang"
                item-value="id"
                :items="$storeCatalogue.ConnaissanceFirsi"
                ref="connufirsi"
                class="asterisk"
              ></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-show="
                  $storeBourse.DonneesFormulaireEC.infosComplementaires?.connaissanceFirsi ==
                  $storeCatalogue.DataId.ConnaissanceFirsiAutre
                "
                label="Préciser"
                :disabled="$storeBourse.DonneesFormulaireEC.readOnly"
                v-model="$storeBourse.DonneesFormulaireEC.infosComplementaires.preciserConnaissance"
                ref="preciserConnaissanceFir"
                :rules="
                  $storeBourse.DonneesFormulaireEC.infosComplementaires
                    ?.connaissanceFirsi ==
                  $storeCatalogue.DataId.ConnaissanceFirsiAutre
                    ? $storeReglesBourse.obligatoire
                    : []
                "
                class="asterisk"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <h3>{{ $storeUm6p.Label.Title.Adresses }}</h3>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="panel-content">
          <h4>{{ $storeUm6p.Label.Candidat.AdresseMa }}</h4>
          <v-divider></v-divider>
          <v-row>
            <v-col cols="9">
              <v-text-field
                :label="$storeUm6p.Label.Candidat.AdresseMaroc"
                v-model="$storeBourse.DonneesFormulaireEC.adresseMaroc"
                :disabled="$storeBourse.DonneesFormulaireEC.readOnly"
                :rules="$storeReglesBourse.obligatoire"
                ref="AdresseMaroc"
                class="asterisk"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-autocomplete
                :label="$storeUm6p.Label.Candidat.PaysMaroc"
                v-model="$storeBourse.DonneesFormulaireEC.paysMaroc"
                :disabled="$storeBourse.DonneesFormulaireEC.readOnly"
                :rules="$storeReglesBourse.obligatoire"
                ref="PaysMaroc"
                :item-text="$storeCommun.ItemLang"
                item-value="id"
                :items="$storeCatalogue.Pays"
                :clearable="!$storeBourse.DonneesFormulaireEC.readOnly"
                class="asterisk"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-text-field
                :label="$storeUm6p.Label.Candidat.CpMaroc"
                v-model="$storeBourse.DonneesFormulaireEC.cpMaroc"
                :disabled="$storeBourse.DonneesFormulaireEC.readOnly"
                :rules="$storeReglesBourse.obligatoireLengthDix"
                ref="CpMaroc"
                class="asterisk"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                :label="$storeUm6p.Label.Candidat.VilleMaroc"
                v-model="$storeBourse.DonneesFormulaireEC.villeMaroc"
                :disabled="$storeBourse.DonneesFormulaireEC.readOnly"
                :rules="$storeReglesBourse.obligatoire"
                ref="VilleMaroc"
                class="asterisk"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-autocomplete
                v-if="
                  $storeBourse.DonneesFormulaireEC.paysMaroc ===
                  $storeCatalogue.DataId.Maroc
                "
                :label="$storeUm6p.Label.Candidat.ProvinceMaroc"
                v-model="$storeBourse.DonneesFormulaireEC.provinceMaroc"
                :disabled="$storeBourse.DonneesFormulaireEC.readOnly"
                :rules="$storeReglesBourse.obligatoire"
                ref="ProvinceMaroc"
                :item-text="$storeCommun.ItemLang"
                item-value="id"
                :items="$storeCatalogue.Province"
                :clearable="!$storeBourse.DonneesFormulaireEC.readOnly"
                @change="ProvinceChange()"
                class="asterisk"
              ></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-autocomplete
                v-if="
                  $storeBourse.DonneesFormulaireEC.paysMaroc ==
                  $storeCatalogue.DataId.Maroc
                "
                :label="$storeUm6p.Label.Candidat.RegionMaroc"
                v-model="$storeBourse.DonneesFormulaireEC.regionMaroc"
                disabled
                ref="RegionMaroc"
                :item-text="$storeCommun.ItemLang"
                item-value="id"
                :items="$storeCatalogue.Region"
                :clearable="!$storeBourse.DonneesFormulaireEC.readOnly"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <h4>{{ $storeUm6p.Label.Candidat.AdresseAu }}</h4>
          <v-divider></v-divider>
          <v-row>
            <v-col cols="9">
              <v-text-field
                :label="$storeUm6p.Label.Candidat.AdresseAutre"
                v-model="$storeBourse.DonneesFormulaireEC.adresseAutre"
                :disabled="$storeBourse.DonneesFormulaireEC.readOnly"
                ref="AdresseAutre"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-autocomplete
                :label="$storeUm6p.Label.Candidat.PaysAutre"
                v-model="$storeBourse.DonneesFormulaireEC.paysAutre"
                :disabled="$storeBourse.DonneesFormulaireEC.readOnly"
                ref="PaysAutre"
                :item-text="$storeCommun.ItemLang"
                item-value="id"
                :items="$storeCatalogue.Pays"
                :clearable="!$storeBourse.DonneesFormulaireEC.readOnly"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <!-- etranger : province/pays/CP -->
          <v-row>
            <v-col cols="6">
              <v-text-field
                :label="$storeUm6p.Label.Candidat.CpAutre"
                v-model="$storeBourse.DonneesFormulaireEC.cpAutre"
                :disabled="$storeBourse.DonneesFormulaireEC.readOnly"
                :rules="$storeReglesBourse.LengthDix"
                ref="CpAutre"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                :label="$storeUm6p.Label.Candidat.VilleAutre"
                v-model="$storeBourse.DonneesFormulaireEC.villeAutre"
                :disabled="$storeBourse.DonneesFormulaireEC.readOnly"
                ref="VilleAutre"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-autocomplete
                :label="$storeUm6p.Label.Candidat.DepartementFrance"
                v-model="$storeBourse.DonneesFormulaireEC.departementFrance"
                :disabled="$storeBourse.DonneesFormulaireEC.readOnly"
                ref="DepartementFrance"
                :item-text="$storeCommun.ItemLang"
                item-value="id"
                :items="$storeCatalogue.DepartementFrance"
                :clearable="!$storeBourse.DonneesFormulaireEC.readOnly"
                v-show="
                  $storeBourse.DonneesFormulaireEC.paysAutre ==
                  $storeCatalogue.DataId.France
                "
                @change="DepartementChange()"
              ></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-autocomplete
                :label="$storeUm6p.Label.Candidat.RegionFrance"
                v-model="$storeBourse.DonneesFormulaireEC.regionFrance"
                :disabled="$storeBourse.DonneesFormulaireEC.readOnly"
                ref="RegionFrance"
                :item-text="$storeCommun.ItemLang"
                item-value="id"
                :items="$storeCatalogue.RegionFrance"
                :clearable="!$storeBourse.DonneesFormulaireEC.readOnly"
                v-show="
                  $storeBourse.DonneesFormulaireEC.paysAutre ==
                  $storeCatalogue.DataId.France
                "
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <h3>{{ $storeUm6p.Label.Title.EtatFamilial }}</h3>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="panel-content">
          <!-- Etat familiale -->
          <v-row>
            <v-col cols="4">
              <!-- Etes-vous? -->
              <v-autocomplete
                :label="$storeUm6p.Label.Candidat.EtesVous"
                v-model="$storeBourse.DonneesFormulaireEC.infosComplementaires.etesVous"
                :disabled="$storeBourse.DonneesFormulaireEC.readOnly"
                :rules="$storeReglesBourse.obligatoire"
                :item-text="$storeCommun.ItemLang"
                item-value="id"
                :items="$storeCatalogue.EtesVous"
                :clearable="!$storeBourse.DonneesFormulaireEC.readOnly"
                class="asterisk"
              ></v-autocomplete>
            </v-col>
            <v-col cols="4">
              <!-- Si à la charge d'un de mes parents -->
              <v-autocomplete
                :label="$storeUm6p.Label.Candidat.GardeConfiee"
                v-model="$storeBourse.DonneesFormulaireEC.infosComplementaires.chargeUnParent"
                :disabled="$storeBourse.DonneesFormulaireEC.readOnly"
                :rules="
                  $storeBourse.DonneesFormulaireEC.infosComplementaires
                    .etesVous == $storeCatalogue.DataId.ChargeUnParentDivorce ||
                  $storeBourse.DonneesFormulaireEC.infosComplementaires
                    .etesVous == $storeCatalogue.DataId.ChargeUnParentVeuf
                    ? $storeReglesBourse.obligatoire
                    : []
                "
                :item-text="$storeCommun.ItemLang"
                item-value="id"
                :items="$storeCatalogue.ChargeParent"
                :clearable="!$storeBourse.DonneesFormulaireEC.readOnly"
                v-show="
                  $storeBourse.DonneesFormulaireEC.infosComplementaires
                    .etesVous == $storeCatalogue.DataId.ChargeUnParentDivorce ||
                  $storeBourse.DonneesFormulaireEC.infosComplementaires
                    .etesVous == $storeCatalogue.DataId.ChargeUnParentVeuf
                "
                class="asterisk"
              ></v-autocomplete>
            </v-col>
            <v-col cols="4">
              <!-- situation parents ? -->
              <v-autocomplete
                :label="
                  $storeBourse.DonneesFormulaireEC.infosComplementaires
                    .etesVous == $storeCatalogue.DataId.ChargeUnParentDivorce
                    ? $storeUm6p.Label.Candidat.ParentTuteurDivorce
                    : $storeUm6p.Label.Candidat.ParentTuteurVeuf
                "
                v-model="$storeBourse.DonneesFormulaireEC.infosComplementaires.parentTuteurDivorce"
                :disabled="$storeBourse.DonneesFormulaireEC.readOnly"
                :rules="
                  $storeBourse.DonneesFormulaireEC.infosComplementaires
                    .etesVous == $storeCatalogue.DataId.ChargeUnParentDivorce ||
                  $storeBourse.DonneesFormulaireEC.infosComplementaires
                    .etesVous == $storeCatalogue.DataId.ChargeUnParentVeuf
                    ? $storeReglesBourse.obligatoire
                    : []
                "
                :item-text="$storeCommun.ItemLang"
                item-value="id"
                :items="filteredSituationParent"
                :clearable="!$storeBourse.DonneesFormulaireEC.readOnly"
                v-show="
                  $storeBourse.DonneesFormulaireEC.infosComplementaires
                    .etesVous == $storeCatalogue.DataId.ChargeUnParentDivorce ||
                  $storeBourse.DonneesFormulaireEC.infosComplementaires
                    .etesVous == $storeCatalogue.DataId.ChargeUnParentVeuf
                "
                class="asterisk"
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <h3>{{ $storeUm6p.Label.Title.SituationFinanciere }}</h3>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="panel-content">
          <!-- Situation financiète et pro -->
          <v-row>
            <v-col cols="6">
              <!-- Vous êtes ? -->
              <v-autocomplete
                :label="$storeUm6p.Label.Candidat.VousEtes"
                v-model="$storeBourse.DonneesFormulaireEC.infosComplementaires.vousEtes"
                :disabled="$storeBourse.DonneesFormulaireEC.readOnly"
                :item-text="$storeCommun.ItemLang"
                item-value="id"
                :items="$storeCatalogue.VousEtes"
                :clearable="!$storeBourse.DonneesFormulaireEC.readOnly"
              ></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <!-- Revenu net Mensuel si autre qu' etudiant -->
              <v-text-field
                :label="$storeUm6p.Label.Candidat.RevenuNetMensuel"
                v-model="$storeBourse.DonneesFormulaireEC.infosComplementaires.revenuNetMensuel"
                :disabled="$storeBourse.DonneesFormulaireEC.readOnly"
                :rules="
                  $storeBourse.DonneesFormulaireEC.infosComplementaires
                    .vousEtes &&
                  $storeBourse.DonneesFormulaireEC.infosComplementaires
                    .vousEtes != $storeCatalogue.DataId.VousEtesEtudiant
                    ? $storeReglesBourse.obligatoire
                    : []
                "
                v-show="
                  $storeBourse.DonneesFormulaireEC.infosComplementaires
                    .vousEtes &&
                  $storeBourse.DonneesFormulaireEC.infosComplementaires
                    .vousEtes != $storeCatalogue.DataId.VousEtesEtudiant
                "
                class="asterisk"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <!-- Disposez-vous d’un régime de protection sociale ? -->
              <v-autocomplete
                :label="$storeUm6p.Label.Candidat.ProtectionSociale"
                v-model="$storeBourse.DonneesFormulaireEC.infosComplementaires.regimeProtectionSociale"
                :disabled="$storeBourse.DonneesFormulaireEC.readOnly"
                :rules="$storeReglesBourse.obligatoire"
                ref="ProtectionSociale"
                :item-text="$storeCommun.ItemLang"
                item-value="id"
                :items="$storeCatalogue.OuiNon"
                :clearable="!$storeBourse.DonneesFormulaireEC.readOnly"
                class="asterisk"
              ></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <!-- Si oui, veuillez préciser auprès de quel organisme -->
              <v-text-field
                :label="$storeUm6p.Label.Candidat.OrganismeProtectionSociale"
                v-model="$storeBourse.DonneesFormulaireEC.infosComplementaires.nomOrganisme"
                :disabled="$storeBourse.DonneesFormulaireEC.readOnly"
                :rules="
                  $storeBourse.DonneesFormulaireEC.infosComplementaires
                    .regimeProtectionSociale == $storeCatalogue.DataId.Oui
                    ? $storeReglesBourse.obligatoire
                    : []
                "
                v-show="
                  $storeBourse.DonneesFormulaireEC.infosComplementaires
                    .regimeProtectionSociale == $storeCatalogue.DataId.Oui
                "
                class="asterisk"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <!-- Nombre de compte bancaire -->
              <v-autocomplete
                :label="$storeUm6p.Label.Candidat.NombreCompteBancaire"
                v-model="$storeBourse.DonneesFormulaireEC.infosComplementaires.nbCompteBancaire"
                :disabled="$storeBourse.DonneesFormulaireEC.readOnly"
                :rules="$storeReglesBourse.obligatoire"
                ref="NombreCompteBancaire"
                :item-text="$storeCommun.ItemLang"
                item-value="id"
                :items="$storeCatalogue.NbCompteBancaire"
                :clearable="!$storeBourse.DonneesFormulaireEC.readOnly"
                class="asterisk"
              ></v-autocomplete>
            </v-col>
            <v-col cols="6"> </v-col>
          </v-row>
          <v-row>
            <v-col cols="8">
              <!-- Bénéficiez-vous d’une bourse supplémentaire pour vos études ? -->
              <v-autocomplete
                :label="$storeUm6p.Label.Candidat.BourseSupplementaire"
                v-model="$storeBourse.DonneesFormulaireEC.bourseSupplementaire"
                :disabled="$storeBourse.DonneesFormulaireEC.readOnly"
                :rules="$storeReglesBourse.obligatoire"
                ref="BourseSupplementaire"
                :item-text="$storeCommun.ItemLang"
                item-value="id"
                :items="$storeCatalogue.OuiNon"
                :clearable="!$storeBourse.DonneesFormulaireEC.readOnly"
                class="asterisk"
              />
            </v-col>
            <v-col cols="4"> </v-col>
          </v-row>
          <AutresBourses
            v-show="
              $storeBourse.DonneesFormulaireEC.bourseSupplementaire ==
              $storeCatalogue.DataId.Oui
            "
          />
          <div v-if="affichageAutreRevenu == true">
            <AutresRevenusCandidat ref="refAutresRevenusCandidat" />
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-form>
</template>
<script>
import moment from "moment";
import AutresBourses from "./AutresBourses.vue";
import AutresRevenusCandidat from "./AutresRevenusCandidat.vue";

export default {
  components: {
    AutresRevenusCandidat,
    AutresBourses,
  },
  props: {
    affichageAutreRevenu: Boolean,
  },
  data() {
    return {
      $storeCatalogue: this.$storeCatalogue,
      menu: {
        dateNaissance: false,
      },
      Panel: {
        Model: [0, 1, 2, 3],
      },
    };
  },
  created() {
  },
  methods: {
    SituationHandicapChange(){
      if(this.$storeBourse.DonneesFormulaireEC.situationHandicap === this.$storeCatalogue.DataId.Non){
        this.$storeBourse.DonneesFormulaireEC.typeHandicap = [];
      }
    },
    // méthodes on change
    ProvinceChange() {
      this.$storeBourse.DonneesFormulaireEC.regionMaroc =
        this.$storeCatalogue.GetParentId(
          this.$storeCatalogue.Province,
          this.$storeBourse.DonneesFormulaireEC.provinceMaroc
        );
    },
    DepartementChange() {
      this.$storeBourse.DonneesFormulaireEC.regionFrance =
        this.$storeCatalogue.GetParentId(
          this.$storeCatalogue.DepartementFrance,
          this.$storeBourse.DonneesFormulaireEC.departementFrance
        );
    },
    ValiderForm() {
      let clesExclues = ["refCandidat", "refAutresRevenusCandidat"];
      let listeErreur = [];
      listeErreur = this.$storeBourse.ValiderForm(
        this.$refs.refCandidat,
        clesExclues
      );

      if (
        this.$storeBourse.DonneesFormulaireEC.bourseSupplementaire ==
          this.$storeCatalogue.DataId.Oui &&
        this.$storeBourse.DonneesFormulaireEC.listeAutresBourses?.length < 1
      ) {
        listeErreur.push("Autre(s) bourse(s)");
      }

      return listeErreur;
    },
  },
  computed: {
    DateNaissanceFormated() {
      return this.$storeBourse.FormatDate(
        this.$storeBourse.DonneesFormulaireEC.dateNaissance
      );
    },
    MaxDateNaissance() {
      return moment(String(new Date()))
        .subtract(15, "year")
        .format("YYYY-MM-DD");
    },
    filteredSituationParent() {
      switch (
        this.$storeBourse.DonneesFormulaireEC.infosComplementaires
          .chargeUnParent
      ) {
        case this.$storeCatalogue.DataId.GardeMere:
        case this.$storeCatalogue.DataId.TutelleMere:
          return this.$storeCatalogue.SituationParent.filter(
            (item) =>
              item.id === this.$storeCatalogue.DataId.MereRemarieNon ||
              item.id === this.$storeCatalogue.DataId.MereRemarieOui
          );
        default:
          return this.$storeCatalogue.SituationParent.filter(
            (item) =>
              item.id === this.$storeCatalogue.DataId.PereRemarieNon ||
              item.id === this.$storeCatalogue.DataId.PereRemarieOui
          );
      }
    },
  },
  mounted() {
    this.$refs.refCandidat.resetValidation();
  },
};
</script>
